module.exports = __webpack_public_path__ + "img/bg.61fd590e.svg";